import { createStyles, makeStyles, type Theme } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        controlsContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: theme.spacing(3),
            gap: theme.spacing(2)
        },
        navigationButton: {
            'width': '40px',
            'height': '40px',
            'borderRadius': '50%',
            'backgroundColor': '#fff',
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'boxShadow': '0 2px 8px rgba(0,0,0,0.1)',
            'cursor': 'pointer',
            'border': '1px solid #eee',
            '&:hover': {
                backgroundColor: '#f5f5f5'
            },
            '&:disabled': {
                opacity: 0.5,
                cursor: 'not-allowed'
            }
        },
        dotsContainer: {
            display: 'flex',
            justifyContent: 'center',
            gap: theme.spacing(1)
        },
        dot: {
            'width': '8px',
            'height': '8px',
            'borderRadius': '50%',
            'backgroundColor': '#F2D2A2',
            'cursor': 'pointer',
            'transition': 'all 0.3s ease',
            '&.active': {
                backgroundColor: '#C18733',
                width: '24px',
                borderRadius: '4px'
            }
        }
    })
);

interface ControlsProps {
    selectedIndex: number;
    slidesCount: number;
    isMobile: boolean;
    onPrevClick: () => void;
    onNextClick: () => void;
    onDotClick: (index: number) => void;
}

export default function Controls({
    selectedIndex,
    slidesCount,
    isMobile,
    onPrevClick,
    onNextClick,
    onDotClick
}: ControlsProps) {
    const classes = useStyles();

    return (
        <Box className={classes.controlsContainer}>
            {isMobile && slidesCount > 1 && (
                <button
                    className={classes.navigationButton}
                    onClick={onPrevClick}
                >
                    <FontAwesomeIcon
                        icon={faChevronLeft}
                        size="lg"
                    />
                </button>
            )}

            {slidesCount > 1 && (
                <Box className={classes.dotsContainer}>
                    {Array.from({ length: slidesCount }).map((_, index) => (
                        <Box
                            key={index}
                            className={`${classes.dot} ${index === selectedIndex ? 'active' : ''}`}
                            onClick={() => onDotClick(index)}
                        />
                    ))}
                </Box>
            )}

            {isMobile && slidesCount > 1 && (
                <button
                    className={classes.navigationButton}
                    onClick={onNextClick}
                >
                    <FontAwesomeIcon
                        icon={faChevronRight}
                        size="lg"
                    />
                </button>
            )}
        </Box>
    );
}
